import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function DetoxPackage() {
  const { i18n } = useTranslation('offer-package');

  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (i18n.language === 'de') {
    return (
      <div className="bg-white border-2 border-[#155f4f] grid md:grid-cols-2">
        <div
          className={classNames(
            'px-14 py-12 flex flex-col font-light space-y-8',
            isOpen ? 'hidden' : 'block'
          )}
        >
          <h2 className="uppercase text-[#155f4f] text-6xl">
            <strong className="font-bold">Detox</strong>
            <br />
            <strong className="font-bold">Delight</strong>
            <br />
            Box
          </h2>

          <p className="text-4xl uppercase text-[#155f4f]">
            Ihre Detox Auszeit <br />
            beginnt jetzt!
          </p>

          <button
            type="button"
            className="uppercase text-white bg-[#155f4f] p-4"
            onClick={() => setIsOpen(true)}
          >
            Mehr erfahren
          </button>
        </div>

        <div
          className={classNames('w-full h-full', isOpen ? 'hidden' : 'block')}
        >
          <img
            src="https://cdn.mandira-ayurveda.at/images/products/2020/detox-pack-white-bg.webp"
            alt="Detox-Package"
            className="object-cover h-full w-full"
          ></img>
        </div>

        <div
          className={classNames(
            'col-span-full p-8 text-lg space-y-4',
            isOpen ? 'block' : 'hidden'
          )}
        >
          <button
            type="button"
            className="uppercase text-white bg-[#155f4f] px-5 py-3 flex gap-2 items-center"
            onClick={() => setIsOpen(false)}
          >
            <ArrowLeftIcon className="size-6" /> zurück
          </button>

          <h3>
            Bereiten Sie sich bereits zu Hause optimal auf Ihre Kur vor! Hierfür
            empfehlen wir Ihnen unser <strong>Pre-Detox-Paket</strong>
          </h3>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <h4 className="font-bold">
                Premium Paket: Pre Detox Plus für €138
              </h4>
              <ul className="list list-disc list-inside">
                <li>
                  inkl. Buch mit vielen Tipps, Rezeptwelt, Yogaübungen uvm.
                </li>
                <li>Ablaufplan</li>
                <li>Mandira-Maßband</li>
                <li>Agni-Plus</li>
                <li>Wellintest</li>
                <li>Livell</li>
                <li>Mibiwell</li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold">
                Basis Paket: Pre Detox Basic für €89
              </h4>
              <ul className="list list-disc list-inside">
                <li>
                  inkl. Buch mit vielen Tipps, Rezeptwelt, Yogaübungen uvm.
                </li>
                <li>Ablaufplan</li>
                <li>Mandira-Maßband</li>
                <li>Agni-Plus</li>
                <li>Wellintest</li>
                <li>Livell</li>
              </ul>
            </div>
          </div>
          <p>
            Kontaktieren Sie uns gerne für nähere Informationen telefonisch
            unter{' '}
            <a href="tel:+4344442801" className="hover:underline font-bold">
              +43 3333 2801
            </a>
            {'. '}
            Alle Preise sind in brutto, zzgl. Versandkosten.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border-2 border-[#155f4f] mx-4 md:mx-8 grid md:grid-cols-2">
      <div
        className={classNames(
          'px-14 py-12 flex flex-col font-light space-y-8',
          isOpen ? 'hidden' : 'block'
        )}
      >
        <h2 className="uppercase text-[#155f4f] text-6xl">
          <strong className="font-bold">Detox</strong>
          <br />
          <strong className="font-bold">Delight</strong>
          <br />
          Box
        </h2>

        <p className="text-4xl uppercase text-[#155f4f]">
          Your detox time-out <br />
          starts now!
        </p>

        <button
          type="button"
          className="uppercase text-white bg-[#155f4f] p-4"
          onClick={() => setIsOpen(true)}
        >
          Learn more
        </button>
      </div>

      <div className={classNames('w-full h-full', isOpen ? 'hidden' : 'block')}>
        <img
          src="https://cdn.mandira-ayurveda.at/images/products/2020/detox-pack-white-bg.webp"
          alt="Detox-Package"
          className="object-cover h-full w-full"
        ></img>
      </div>

      <div
        className={classNames(
          'col-span-full p-8 text-lg space-y-4',
          isOpen ? 'block' : 'hidden'
        )}
      >
        <button
          type="button"
          className="uppercase text-white bg-[#155f4f] px-5 py-3 flex gap-2 items-center"
          onClick={() => setIsOpen(false)}
        >
          <ArrowLeftIcon className="size-6" /> go back
        </button>

        <h3>
          Prepare yourself optimally for your cure at home! For this we
          recommend our <strong>Pre-Detox-Paket!</strong>
        </h3>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <h4 className="font-bold">
              Premium package: Pre Detox Plus for €138
            </h4>
            <ul className="list list-disc list-inside">
              <li>
                incl. book with lots of tips, recipes, yoga exercises and much
                more
              </li>
              <li>schedule</li>
              <li>measuring tape</li>
              <li>Agni-Plus</li>
              <li>Wellintest</li>
              <li>Livell</li>
              <li>Mibiwell</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold">
              Basic package: Pre Detox basic for €89
            </h4>
            <ul className="list list-disc list-inside">
              <li>
                incl. book with lots of tips, recipes, yoga exercises and much
                more
              </li>
              <li>schedule</li>
              <li>measuring tape</li>
              <li>Agni-Plus</li>
              <li>Wellintest</li>
              <li>Livell</li>
            </ul>
          </div>
        </div>
        <p>
          Please contact us for further information by telephone{' '}
          <a href="tel:+4344442801" className="hover:underline font-bold">
            +43 3333 2801
          </a>
          {'. '}
          Price does not include shipping costs.
        </p>
      </div>
    </div>
  );
}

export default DetoxPackage;
